/**
 * E2.4a — canonical execution overlay hierarchy (documentation + UI labels).
 *
 * 1. Execution State (authoritative projection)
 * 2. Health State (diagnostic)
 * 3. Adaptive State Overlay (recovery semantics)
 * 4. Coordination Impact
 * 5. Governance / Compliance
 */

export type HierarchyLayerId =
  | 'execution'
  | 'health'
  | 'adaptive'
  | 'coordination'
  | 'governance';

export const HIERARCHY_LAYER_ORDER: HierarchyLayerId[] = [
  'execution',
  'health',
  'adaptive',
  'coordination',
  'governance'
];

export const HIERARCHY_UI_LABELS: Record<HierarchyLayerId, string> = {
  execution: 'Исполнение',
  health: 'Состояние',
  adaptive: 'Recovery',
  coordination: 'Координация',
  governance: 'Контроль'
};

/** Avoid duplicate user-facing delay text between health and adaptive. */
export function adaptiveDisplaySummary(params: {
  healthLabel: string | null;
  adaptiveLabel: string;
  overlayNote: string | null;
  hasConfirmedDelay: boolean;
  hasConfirmedWaiting: boolean;
}): { summary: string; detail: string | null } {
  if (params.hasConfirmedWaiting) {
    return { summary: 'Ожидание подтверждено', detail: params.overlayNote };
  }
  if (params.hasConfirmedDelay) {
    return {
      summary: 'Задержка под контролем',
      detail: params.overlayNote ?? 'Controlled delay'
    };
  }
  if (params.healthLabel && params.adaptiveLabel === params.healthLabel) {
    return { summary: params.adaptiveLabel, detail: params.overlayNote };
  }
  return { summary: params.adaptiveLabel, detail: params.overlayNote };
}
